
import { defineComponent, onMounted, ref, computed } from "vue";
import ModalV3 from "@/app/ui/components/modal/modal-v3.vue";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import { RevenueDashboardController } from "@/app/ui/controllers/RevenueDashboardController";
import {
  RevenueDashboardCustomerListRequest,
  CustomerLeaderboard
} from "@/domain/entities/RevenueDashboard";
import moment from "moment";
import { AccountController } from '@/app/ui/controllers/AccountController';
import formatPriceRP from '@/app/infrastructures/misc/common-library/v2/FormatPriceRP';

export default defineComponent({
  name: "PopupTopCustomer",
  components: { ModalV3, LpButton, Skeleton, EmptyState },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const visible = computed({
      get: () => props.modelValue,
      set: (val: boolean) => emit("update:modelValue", val)
    });
    const loading = ref(false);
    const topCustomers = ref<CustomerLeaderboard[]>([]);

    const fetchTop = async () => {
      loading.value = true;
      try {
        const resp = await RevenueDashboardController.getCustomerLeaderboard(
          new RevenueDashboardCustomerListRequest({
            page: 1,
            limit: 10,
            tag: "",
            customerName: "",
            sortBy: "",
            orderBy: ""
          } as any)
        );
        topCustomers.value = Array.isArray(resp?.data)
          ? resp.data.slice(0, 10)
          : [];
      } finally {
        loading.value = false;
      }
    };

    const close = () => {
      visible.value = false;
    };
    const accountCurrency = computed(() => {
      return (
        (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ??
        "IDR"
      );
    });
    const formatCurrency = (v: number) => formatPriceRP(Number(v || 0), accountCurrency.value);
    const formatDate = (d: string) =>
      d ? moment(d).format("DD MMM YYYY, HH:mm") : "-";
    const maskPhone = (phone: string) => {
      if (!phone) return "";
      const clean = phone.replace(/[^0-9]/g, "");
      if (clean.length <= 6) return clean;
      const start = clean.slice(0, 4);
      const end = clean.slice(-3);
      return `${start}*****${end}`;
    };
    const openWhatsApp = (phone: string) => {
      const cleaned = (phone || "").replace(/[^0-9]/g, "");
      const url = `https://wa.me/${cleaned}`;
      window.open(url, "_blank");
    };

    onMounted(fetchTop);

    return {
      visible,
      loading,
      topCustomers,
      close,
      formatCurrency,
      formatDate,
      maskPhone,
      openWhatsApp
    };
  }
});
